<template>
  <el-dialog custom-class="min-dialog" :title="title" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false">
    <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
      <el-form-item label="密码：" prop="oldPassword">
        <el-input type="password" v-model="ruleForm2.oldPassword" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="变更账号：" v-if="ShowChangeZH">
        <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="query-table">
          <tr v-for="(item,index) in TenantList">
            <td class="content">
              <el-checkbox checked :label="item.tenantname" @change="needchange(index,item)"></el-checkbox>
            </td>
          </tr>
        </table>
      </el-form-item>
      <el-form-item label="新手机号：" prop="mobile">
        <el-input v-model="ruleForm2.mobile" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="smsiden">
        <el-input v-model="ruleForm2.smsiden" auto-complete="off" style="width: 60%;"></el-input>
        <el-button type="primary" round @click="getCode" :disabled="!canpost">获取验证码{{countName}}</el-button>
      </el-form-item>
      <el-form-item label="新号密码：" prop="newPassword" v-if="ShowNewPass">
        <el-input type="password" v-model="ruleForm2.newPassword" auto-complete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm2')" :disabled="isDisable">提交</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {updatePhone,sendVerificationCode} from '../../api/login'

  export default {
    data() {
      return {
        countName:'',
        count:60,
        timer:null,
        canpost:true,
        isDisable:false,
        title:"",
        ShowChangeZH:false,
        ShowNewPass:false,
        dialogFormVisible: false,
        TenantList:[],
        ruleForm2: {
          newPassword: '',
          mobile: '',
          oldPassword: '',
          smsiden:''
        },
        rules2: {
          smsiden: [
            {required: true, message: '请输入验证码', trigger: 'blur'},
          ],
          newPassword: [
            {required: true, message: '请输入新手机号的密码', trigger: 'blur'},
          ],
          oldPassword: [
            {required: true, message: '请输入密码', trigger: 'blur'},
          ],
          mobile: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {pattern: /^0{0,1}(1[0-9][0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/, message: '请输入正确的手机号', trigger: 'blur'},
          ],
        }
      };
    },
    methods: {
      needchange(index,item){
        item.checked=!item.checked;
      },
      getCode(){
        if(this.ruleForm2.mobile=='')
          return;
        const TIME_COUNT = 60;
        if (!this.timer) {
          var self=this;
          self.count = TIME_COUNT;
          if(self.canpost){
            sendVerificationCode({type:'changephone',mobile:this.ruleForm2.mobile}).then(response=>{
              this.$message({
                message: '验证码发送成功！',
                type: 'success'
              })
            });
          }
          self.canpost = false;
          self.timer = setInterval(() => {
            if (self.count > 0 && self.count <= TIME_COUNT) {
              self.count--;
              self.countName='（'+self.count+'s）';
            } else {
              self.canpost = true;
              self.countName='';
              clearInterval(self.timer);
              self.timer = null;
            }
          }, 1000)
        }
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {   //调用登录接口
            var CT='';
            for (var i = 0, l = this.TenantList.length; i < l; i++) {
              if(this.TenantList[i].checked)
                CT+=this.TenantList[i].unitguid+'|'+this.TenantList[i].uguid+';';
            }
            if(CT=='')
            {
              this.$message.error({message: '请选择需要变更的账号！'});
              return false;
            }
            this.isDisable = true;

            updatePhone({
              oldPassword: this.ruleForm2.oldPassword,
              newPassword: this.ruleForm2.newPassword,
              mobile:this.ruleForm2.mobile,
              smsiden:this.ruleForm2.smsiden,
              ChangeTenant:CT
            }).then(response => {
              if (response.data.code == 0) {//修改密码成功
                this.$message({
                  message: '号码修改成功，请重新登录！',
                  type: 'success'
                })
                this.dialogFormVisible=false;
                this.$emit('logout');
              }  if (response.data.code == 2) {
                this.$message.error({message: response.data.msg});
                this.ShowNewPass=true;
              }
              else {
                this.$message.error({message: response.data.msg});
              }
              this.isDisable = false;
            }).catch((error) => {
              console.log(error)
            });
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      show(){
        this.dialogFormVisible=true;
      }
    },
    mounted() {
      //个人信息
      var userinfo = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      //多企业信息
      var tokenInfo = JSON.parse(localStorage.getItem("hpapi_tokenModel"));
      this.TenantList=tokenInfo.tenantDO;
      for (var i = 0, l = this.TenantList.length; i < l; i++) {
        this.TenantList[i].checked=true;
      }
      if(this.TenantList.length>1){
        this.ShowChangeZH=true;
      }
      this.title="变更手机（"+userinfo.mobile+"）";
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index/ChangePhone.vue